/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGenderAgender = createReactComponent("gender-agender", "IconGenderAgender", [
  ["path", { d: "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0", key: "svg-0" }],
  ["path", { d: "M7 12h11", key: "svg-1" }]
]);

export { IconGenderAgender as default };
//# sourceMappingURL=IconGenderAgender.js.map
